import { render, staticRenderFns } from "./mediaToText.vue?vue&type=template&id=1bcdab80&scoped=true&"
import script from "./mediaToText.vue?vue&type=script&lang=js&"
export * from "./mediaToText.vue?vue&type=script&lang=js&"
import style0 from "@assets/css/mediaDetails/mediaChange.less?vue&type=style&index=0&id=1bcdab80&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1bcdab80",
  null
  
)

component.options.__file = "mediaToText.vue"
export default component.exports